module.exports = __webpack_public_path__ + "static/inner-chat-91be8cc3de0a641031bce60ed7f72d02.png";